export type AccountRoute =
  | { page: "login" }
  | { page: "consumer-registration" }
  | { page: "organization-access"; registration: boolean }
  | { page: "consumer-account" }
  | { page: "organization-workspace"; slug: string }
  | { page: "not-found" };

export function resolveAccountRoute(pathname: string): AccountRoute {
  if (pathname === "/kirjaudu") return { page: "login" };
  if (pathname === "/rekisteroidy") return { page: "consumer-registration" };
  if (pathname === "/organisaatioille/rekisteroidy") {
    return { page: "organization-access", registration: true };
  }
  if (pathname === "/organisaatioille") {
    return { page: "organization-access", registration: false };
  }
  if (pathname === "/oma" || pathname.startsWith("/oma/")) {
    return { page: "consumer-account" };
  }
  if (pathname.startsWith("/organisaatio/")) {
    return {
      page: "organization-workspace",
      slug: decodeURIComponent(pathname.slice("/organisaatio/".length)),
    };
  }
  return { page: "not-found" };
}
